module.exports = __webpack_public_path__ + "67a1aee5dab40801165b371ba9f1ae7d.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-36@2x.png
// module id = 514
// module chunks = 0